import './styles.scss';

import {
  Card,
  Col,
  Row
} from 'reactstrap';
import { Badge, Empty, Statistic } from 'antd';
import { Computer } from 'app/modules/orders/models/Order'
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react';
import { deleteComputer, listComputer } from 'app/modules/orders/redux/OrdersCRUD';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { PageTitle } from '../../../_metronic/layout/core'
import { RootState } from 'setup'
import moment from 'moment'
import { useIntl } from 'react-intl';
import { Button, List, Skeleton } from 'antd'
import { ROLE_GENERAL } from 'utils/constants';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
const RunningStatisticWidget = ({ type }: any) => {
  const intl = useIntl()
  const user: any = useSelector<RootState>(({ auth }) => auth.user, shallowEqual)
  const computersLoading: boolean = (useSelector<RootState>(({ orders }) => orders.computersLoading, shallowEqual) as boolean) || false;

  const [loading, setLoading] = useState(false);
  const [computers, setComputers] = useState<Computer[]>([])
  const [list_uploading, setList_uploading] = useState([])
  const [listLogs, setListLogs] = useState([])
  const [computer_name, setComputer_name] = useState('');
  const [typeVideoReview, setTypeVideoReview] = useState(1);

  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    getComputerList();
    setInterval(getComputerList, 30000);

    // at the end, return a cleanup method
    return () => {};
  }, []);


  const getComputerList = async () => {
    try {
      const response: any = await listComputer();
      if (attempt === 5) {
        setComputers([])
        setList_uploading([]);
        setListLogs([]);
        setLoading(false);
      }

      if (response && response.data) {
        setComputers(response.data.data.computer)
        setList_uploading(response.data.data.list_uploading);
        setListLogs(response.data.data.log);
  
        if (loading === false) {
          setLoading(true);
        }

        setAttempt(0);
      }
    } catch (error) {
      setAttempt(attempt + 1);
    }
  }

  const deleteComputerTask = async (computer_name: string) => {
    if (window.confirm(`Bạn có chắc xóa máy ${computer_name} ?`)) {
      const response: any = await deleteComputer(computer_name);
      window.location.reload();
    }
  }

  const showVideoUploadingTask = async (computer_name: string) => {
    setComputer_name(computer_name);
    setTypeVideoReview(1);
  }
  
  const showVideoUploadedTask = async (computer_name: string) => {
    setComputer_name(computer_name);
    setTypeVideoReview(0);
  }

  let videoDatas: any[];
  if (computer_name) {
    videoDatas = list_uploading.filter((item: any) => {
      if (item.computer === computer_name) {
        return true
      }
      return false
    })
  } else {
    videoDatas = list_uploading
  }

  computers.sort((a, b) => {
    return b.running - a.running
  });;

  return (
    <>
      <div className='row'>
        <div className='col-4'>    
          <div className='card-header-alt mb-3'>
            <div className='text-left font-weight-bold font-size-xl mb-0 text-black'>
              Danh sách server hoạt động
              {
                computers.length > 0 ? <Badge count={computers.length} style={{
                    backgroundColor: '#26695c', borderRadius: '3px', marginBottom: '4px', fontSize: '15px', marginLeft: "5px"
                }} /> : null
              }
            </div>
            <div className='text-left font-size-sm mb-0 text-black-50'>
              {'Click vào từng server để xem danh sách video đang upload'}
            </div>
          </div>
        </div>
        {/* <div className='col-8 text-right'>
          <Card className='card-box px-2 py-2' style={{ width: '15%' }}>
            <div className='card-header-alt'>
              <Statistic
                title="Active"
                value={11.28}
                precision={2}
                loading={loading}
                valueStyle={{ color: '#3f8600' }}
                prefix={<ArrowUpOutlined rev={undefined} />}
                suffix="%"
              />
            </div>
          </Card>
        </div> */}
      </div>

      { !loading ? (
        <Row className='mb-3 row-server'>
          <Col sl={6}>
            <Skeleton active />
          </Col>
          <Col sl={6}>
            <Skeleton active />
          </Col>
        </Row>
      ) : (
        <div className='row mb-2'>
          <div className='col-lg-6 col-md-12 col-sm-12'>
            <Row className='mb-3 row-server'>
              {
                computers.length > 0 ? computers.map((item: any, index: number) => {
                  const color = item.running >= 15 ? 'green' : item.running < 15 && item.running > 5 ? 'yellow' : 'red'
                  return (
                    <Col className='box-col-4 des-xl-25 rate-sec col-sm-12 col-md-12 col-lg-6'>
                      <div className='card'>
                        <div className='text-center card-body'>
                          <div className='row'>
                            <div className='col-lg-6 col-md-12 col-sm-12'>
                              <h5 className='golden-animation-button'>
                                <i className='feather icon-server mr-2'></i>
                                {item.computer}
                                <span className="waves"></span>
                              </h5>
                              {moment.unix(item.start_time).format(' hh:mm A  DD/MM')}
                              {/* <p className='income-card__number'>
                                {intl.formatMessage({ id: 'THREAD_NUMBER' })}: <span className={'income-card__name income-card__name--' + color}>{item.running}</span>
                              </p> */}
                            </div>
                            <div className='col-lg-6 col-md-12 col-sm-12'>
                              <p className='income-card__number'>
                                <Button block style={{ color: "green", borderColor: "green" }} onClick={() => showVideoUploadedTask(item.computer)}>
                                  <i className='feather icon-check mr-1 ml-0 pl-0'></i>
                                  Videos hoàn tất
                                </Button>
                              </p>
                              <p className='income-card__number'>
                                <Button block onClick={() => showVideoUploadingTask(item.computer)}>
                                  <i className='feather icon-arrow-up mr-1 ml-0'></i>
                                  Videos đang tải
                                </Button>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  ) 
                }) : (
                  <div className='text-center my-4' style={{ width: '100%' }}>
                    <Empty />
                  </div>
                )
              }
            </Row>
          </div>
          <div className='col-lg-6 col-md-12 col-sm-12'>
            <Card className='card-box mb-3 px-4 pt-3 pb-3'>
              <span className=' text-black text-lg mb-3'>
                <div className='row'>
                  <div className='col-6'>
                    {
                      typeVideoReview === 0 
                        ? (<>Videos hoàn tất </>) 
                        : (<>Video đang tải </>)
                    }
                  </div>
                  <div className='col-6 text-right'>
                    {
                      computer_name ?
                        <strong><Badge count={`${computer_name} (${videoDatas.length})`} style={{ backgroundColor: '#26695c', borderRadius: '3px', marginBottom: '4px' }} /></strong>
                        : <strong><Badge count={`Tất cả (${videoDatas.length})`} style={{ backgroundColor: '#26695c', borderRadius: '3px', marginBottom: '4px' }} /></strong>
                    }
                  </div>
                </div>
              </span>
              {
                videoDatas.length > 0 ? (
                  <List
                    className='card-list-video'
                    dataSource={videoDatas}
                    renderItem={(item: any) => {
                      return (
                        <List.Item key={item.video_id} className='pl-2 pr-2'>
                          <List.Item.Meta
                            // eslint-disable-next-line jsx-a11y/alt-text
                            avatar={<img referrerPolicy="no-referrer" style={{ borderRadius: '50%', width: '30px', height: '30px' }} src={item.channel_thumb} />}
                            title={<span>{item.title}</span>}
                            description={item.username}
                          />
                          <div>{moment.unix(item.start_time).format('DD/MM HH:mm')}</div>
                        </List.Item>
                      )
                    }}
                  />
                ) : ( 
                  <div className='text-center my-4' style={{ width: '100%' }}>
                    <Empty />
                  </div>
                )
              }
            </Card>
          </div>
        </div>
      )}
      {/* <Card className='card-box mb-3 px-4 pt-3 pb-3'>
        <div className='card-header-alt'>
          <div className='text-left font-weight-bold font-size-lg mb-0 text-black'>Danh sách log</div>
        </div>
      </Card>

      <Row className='mb-6 row-server'>
        <Col sl={6}>
            { !loading ? (
              <Skeleton active />
            ) : <List
              dataSource={listLogs}
              renderItem={(item: any) => (
                <List.Item key={item.id}>
                  <List.Item.Meta
                    title={
                      <div>
                        <span>{item.upload_title}</span>
                      </div>
                    }
                    description={item.content}
                  />
                  <div>{moment.unix(item.created_at).format('DD/MM HH:mm')}</div>
                </List.Item>
              )}
            />}
        </Col>
        <Col sl={6}>

        </Col>
      </Row> */}
    </>
  )
}


const DashboardWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>{'Thống kê'}</PageTitle>
      <Row>
        <Col lg='12'>
          <RunningStatisticWidget type='subscribe' />
        </Col>
      </Row>
    </>
  )
}

export { DashboardWrapper }
